import React from 'react';
import PropTypes from 'prop-types';
import { Card, Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import './style.scss';

const SettingsCard = ({
  bodyMarginBottom,
  colorBorder,
  colorText,
  classNameCard,
  classNameImg,
  classTitle,
  direction,
  divBody,
  path,
  size,
  sizeHeight,
  src,
  subtitle,
  location,
  text,
  title,
  titleBtn,
  variantBtn,
  buttons
}) => (
  <Card
    text={colorText}
    className={`${classNameCard}`}
    style={{ width: size, height: sizeHeight }}
    border={colorBorder}
  >
    {title && location !== 'dashboard' && <Card.Title className={`${classTitle} mt-2 ml-2`}>{title}</Card.Title>}
    {src ? <Card.Img variant={direction} className={classNameImg} src={src} /> : <Card.Img variant={direction} />}
    <Card.Body className="d-flex flex-column h-100" style={{ marginBottom: bodyMarginBottom }}>
      {subtitle && <Card.Subtitle className="mb-2 text-muted">{subtitle}</Card.Subtitle>}
      {divBody ? <div className="flex-grow-1 d-flex flex-column">{text}</div> : <Card.Text>{text}</Card.Text>}
      {divBody ? <div className="flex-grow-1 d-flex flex-column">{buttons}</div> : <Card.Text>{buttons}</Card.Text>}
      {titleBtn && (
        <Button as={Link} variant={variantBtn} to={path}>
          {titleBtn}
        </Button>
      )}
    </Card.Body>
  </Card>
);

SettingsCard.propTypes = {
  colorBorder: PropTypes.string,
  colorText: PropTypes.string,
  classNameCard: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  classNameImg: PropTypes.string,
  classTitle: PropTypes.string,
  direction: PropTypes.string,
  divBody: PropTypes.bool,
  path: PropTypes.string,
  size: PropTypes.string,
  src: PropTypes.string,
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
  titleBtn: PropTypes.string,
  variantBtn: PropTypes.string
};

SettingsCard.defaultProps = {
  colorBorder: null,
  colorText: 'black',
  classNameCard: '',
  classNameImg: '',
  classTitle: '',
  direction: 'top',
  divBody: false,
  path: null,
  size: '18rem',
  src: null,
  subtitle: null,
  titleBtn: null,
  variantBtn: 'info'
};

export default SettingsCard;
